/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Removed_Folder_And_FilesInputs */

const en_toast_removed_folder_and_files = /** @type {(inputs: Toast_Removed_Folder_And_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Removed folder and ${i?.count} file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Removed folder and ${i?.count} files`);
	return /** @type {LocalizedString} */ ("toast_removed_folder_and_files");
};

const es_toast_removed_folder_and_files = /** @type {(inputs: Toast_Removed_Folder_And_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Carpeta eliminada y ${i?.count} archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Carpeta eliminada y ${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("toast_removed_folder_and_files");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Removed folder and {count} file" |
* | "other" | "Removed folder and {count} files" |
*
* @param {Toast_Removed_Folder_And_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_removed_folder_and_files = /** @type {((inputs: Toast_Removed_Folder_And_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Removed_Folder_And_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_removed_folder_and_files(inputs)
	return en_toast_removed_folder_and_files(inputs)
});